import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { GAME_TYPE } from '../../../../services/utilityFunctions';
import translate from '../../../../commonComponents/translate';
import GameTypeProp from '../../../challenges/propTypes/gameTypeProp';
import SectionFilter from '../SectionFilter';
import GameCategoriesProp from '../../../challenges/propTypes/gameCategoriesProp';
import TextFilter from '../../../../commonComponents/lists/filters/TextFilter';

function ChallengeFilters({ t, id, onChange, gameTypes, gameCategories, onChangeCategory, onChangeSearch }) {
  const [filter, setFilter] = useState('');
  const [search, setSearch] = useState('');
  const [gameCategory, setGameCategory] = useState('');

  const handleChange = newFilter => {
    setFilter(newFilter);
    onChange(newFilter);
  };

  const handleCategoryChange = value => {
    setGameCategory(value);
    onChangeCategory(value);
  };

  const handleSearchChange = value => {
    setSearch(value);
    onChangeSearch(value);
  };

  const options = [{ id: '', text: t('all_types') }].concat(
    gameTypes
      .filter(type =>
        [
          GAME_TYPE.CANDIDATES,
          GAME_TYPE.CROSS_SELLING,
          GAME_TYPE.E_LEARNING,
          GAME_TYPE.PRODUCTIVITY,
        ].includes(type.type),
      )
      .map(type => ({
        id: type._id,
        text: t(`challengeDetails_type_${type.type}`),
      })),
  );
  const optionsCategory = [{ id: '', text: t('all_categories') }].concat(
    gameCategories.map(c => ({
        id: c._id,
        text: c.translations.en,
      })),
  );

  return (
    <div className="col-12 col-lg-9 ">
      <div className="row h-100" style={{ alignItems: 'center' }}>
        <div className="col-12 col-lg mb-3 mb-lg-0">
          <TextFilter
            id="searchInput"
            onChange={handleSearchChange}
            placeholder={t('search')}
            value={search}
          />
        </div>
        <div className="col-auto">
          <SectionFilter
            id="gamesCategory"
            items={optionsCategory}
            onChange={handleCategoryChange}
            value={gameCategory}
          />
        </div>
        <div className="col-auto">
          <SectionFilter
            id={id}
            items={options}
            onChange={handleChange}
            value={filter}
          />
        </div>
      </div>
    </div>

  );
}

ChallengeFilters.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onChangeCategory: PropTypes.func.isRequired,
  onChangeSearch: PropTypes.func.isRequired,
  gameTypes: PropTypes.arrayOf(PropTypes.shape(GameTypeProp.propTypes))
    .isRequired,
  gameCategories: PropTypes.arrayOf(PropTypes.shape(GameCategoriesProp.propType))
    .isRequired,
};

export default translate(ChallengeFilters);
